(function(){
  //图片预加载
  let _lazyImageList = [
    'activity.png',
    'activityDark.png',
    'avatar.jpeg',
    'banner.png',
    'bannerDark.png',
    'course.png',
    'courseDark.png',
    'education.png',
    'educationDark.png',
    'finance.png',
    'financeDark.png',
    'logo.png',
    'student.png',
    'studentDark.png',
    'teacher.png',
    'teacherDark.png',
    'dashboard.png',
    'dashboardDark.png',
    'courseGreen.png',
    'institutionPurple.png',
    'schoolBlue.png',
    'studentYellow.png',
  ]
    
  _lazyImageList.map(image =>{
    let _tempImg = document.createElement('img');
    _tempImg.style.display = "none";
    _tempImg.src = `/icon/${image}`;

    document.body.appendChild(_tempImg)
  })
})()

